export default {
  namespaced: true,
  state: {
    showManufacturerMenu: false,
    manufacturerMenuLoading: false,
    selectedManufacturer: null,
    selectedManufacturerSearchTerm: "",
    modelSearchTerm: "",
    modelSelectedAnalytics: null,
    loadedManufacturers: null,
    loadedCompatibleProducts: null,
    showModelsMenu: false,
    manufacturerFilterText: "",
    modelFilterText: "",
    disableManufacturerInput: false
  },
  getters: {
    getShowManufacturerMenu: state => state.showManufacturerMenu,
    isManufacturerMenuLoading: state => state.manufacturerMenuLoading,
    getLoadedManufacturers: state => state.loadedManufacturers,
    getLoadedCompatibleProducts: state => state.loadedCompatibleProducts,
    getShowModelsMenu: state => state.showModelsMenu,
    filteredManufacturerArray: state => {
      if (null === state.loadedManufacturers) {
        return [];
      }

      return state.loadedManufacturers.filter(i =>
        i.ManufacturerName.toLowerCase().includes(
          state.manufacturerFilterText.toLowerCase()
        )
      );
    },
    filteredModelArray: state => {
      if (null === state.loadedCompatibleProducts) {
        return [];
      }

      return state.loadedCompatibleProducts.filter(i =>
        i.Model.toLowerCase().includes(state.modelFilterText.toLowerCase())
      );
    }
  },
  mutations: {
    MANUFACTURER_MENU_TOGGLE(state) {
      state.showManufacturerMenu = !state.showManufacturerMenu;
    },
    MANUFACTURER_MENU_CLOSE(state) {
      state.showManufacturerMenu = false;
    },
    MANUFACTURER_MENU_OPEN(state) {
      state.showManufacturerMenu = true;
    },
    UPDATE_MANUFACTURER_MENU_LOADING(state, bool) {
      state.manufacturerMenuLoading = bool;
    },
    SET_LOADED_MANUFACTURERS(state, manufacturers) {
      state.loadedManufacturers = manufacturers;
    },
    SET_LOADED_COMPATIBLE_PRODUCTS(state, products) {
      state.loadedCompatibleProducts = products;
    },
    MODELS_MENU_OPEN(state) {
      state.showModelsMenu = true;
    },
    MODELS_MENU_CLOSE(state) {
      state.showModelsMenu = false;
    },
    UPDATE_SELECTED_MANUFACTURER(state, selectedManufacturer) {
      if (undefined === selectedManufacturer) {
        return;
      }
      if (null === selectedManufacturer) {
        // reset analytics values
        state.selectedManufacturerSearchTerm = "";
        state.modelSearchTerm = "";
        state.modelSelectedAnalytics = null;
      } else {
        state.selectedManufacturerSearchTerm = state.manufacturerFilterText;
      }
      state.selectedManufacturer = selectedManufacturer;
    },
    UPDATE_MANUFACTURER_FILTER_TEXT(state, updatedText) {
      state.manufacturerFilterText = updatedText;
    },
    UPDATE_MODEL_FILTER_TEXT(state, updatedText) {
      state.modelFilterText = updatedText;
    },
    UPDATE_DISABLE_MANUFACTURER_INPUT(state, bool) {
      state.disableManufacturerInput = bool;
    },
    // reset in UPDATE_SELECTED_MANUFACTURER
    SET_MODEL_ANALYTICS(state, model) {
      state.modelSelectedAnalytics = model;
    },
    SET_MODEL_SEARCH_TERM_ANALYTICS(state, term) {
      state.modelSearchTerm = term;
    }
  },
  actions: {
    manufacturerMenuToggleClicked({ commit }) {
      commit("MANUFACTURER_MENU_TOGGLE");
    },
    updateIsManufacturerMenuLoading({ commit }, bool) {
      commit("UPDATE_MANUFACTURER_MENU_LOADING", bool);
    },
    closeManufacturerMenu({ commit }) {
      commit("MANUFACTURER_MENU_CLOSE");
    },
    openManufacturerMenu({ commit }) {
      commit("MANUFACTURER_MENU_OPEN");
    },
    loadManufacturers({ commit }, manufacturers) {
      commit("SET_LOADED_MANUFACTURERS", manufacturers);
    },
    clearLoadedManufacturers({ commit }) {
      commit("SET_LOADED_MANUFACTURERS", null);
    },
    loadCompatibleProducts({ commit }, products) {
      commit("SET_LOADED_COMPATIBLE_PRODUCTS", products);
    },
    clearCompatibleProducts({ commit }) {
      commit("SET_LOADED_COMPATIBLE_PRODUCTS", null);
    },
    openModelsMenu({ commit }) {
      commit("MODELS_MENU_OPEN");
    },
    closeModelsMenu({ commit }) {
      commit("MODELS_MENU_CLOSE");
    },
    userSelectManufacturer({ commit }, manufacturer) {
      commit("UPDATE_SELECTED_MANUFACTURER", manufacturer);
    },
    updateManufacturerFilterText({ commit }, updatedText) {
      commit("UPDATE_MANUFACTURER_FILTER_TEXT", updatedText);
    },
    updateModelFilterText({ commit }, updatedText) {
      commit("UPDATE_MODEL_FILTER_TEXT", updatedText);
    },
    updateDisableManufacturerInput({ commit }, bool) {
      commit("UPDATE_DISABLE_MANUFACTURER_INPUT", bool);
    },
    setModelSearchTerm({ commit }, term) {
      commit("SET_MODEL_SEARCH_TERM_ANALYTICS", term);
    },
    setModelAnalytics({ commit }, model) {
      commit("SET_MODEL_ANALYTICS", model);
    }
  }
};
